/* eslint no-use-before-define: 0 */

import $ from "jquery";

import { SearchPanelComponent } from "./components/search-panel.component";
// eslint-disable-next-line import/no-cycle
import SearchService from "./services/search.service";
import AutocompleteService from "./services/autocomplete.service";

// eslint-disable-next-line import/prefer-default-export
export const Components = {};

const searchPanelNode = $("#searchPanel");
const searchPanelFrontPageNode = $(".front-page-search-panel");
const apartmentSearchPanelClass = "apartment-search-panel";

function initComponents(options) {
    function initSearchPanel() {
        if (searchPanelNode.length) {
            Components.searchPanel = new SearchPanelComponent(searchPanelNode, false);
        } else if (searchPanelFrontPageNode.length) {
            Components.searchPanel = new SearchPanelComponent(searchPanelFrontPageNode.eq(0), true);
        }
    }

    if (options && options.noFilters) {
        initSearchPanel({ noFilters: true });
        return;
    }

    initSearchPanel();
}

function initServices(options) {
    if (options) {
        const opt = {};
        if (options.noFilters) {
            opt.noFilters = true;
        }
        if (options.apartments) {
            opt.apartments = true;
        }
        // eslint-disable-next-line no-unused-vars
        const searchService = new SearchService(opt);
    } else {
        // eslint-disable-next-line no-unused-vars
        const searchService = new SearchService();
    }

    // eslint-disable-next-line no-unused-vars
    const autocompleteService = new AutocompleteService();
}

function initSearchPanelAndFrontPageSearchPanel() {
    if (
        (searchPanelNode.length && !searchPanelNode.hasClass(apartmentSearchPanelClass))
        || searchPanelFrontPageNode.length
    ) {
        initComponents();
        initServices();
        Components.searchPanel.typeFiltersPanel.setDefaultSelection();
    }
}

function initApartmentSearchPanel() {
    if (searchPanelNode.length && searchPanelNode.hasClass(apartmentSearchPanelClass)) {
        const options = {
            noFilters: true,
            apartments: true,
        };

        initServices(options);
        initComponents(options);
    }
}

initSearchPanelAndFrontPageSearchPanel();
initApartmentSearchPanel();
